<template>
  <div class="page-table scrollable only-y">
    <div class="no-table-box page-header">
      <el-row class="hidden-sm-and-up pb-15">
        <h1>
          <v-svg class="voxo-aqua" sprite="telephone-2" />
          Button Layouts
        </h1>
      </el-row>
      <el-row class="hidden-xs-only pb-15">
        <el-col :span="12">
          <h1>
            <v-svg class="voxo-aqua" sprite="telephone-2" />
            Button Layouts
          </h1>
        </el-col>

        <el-col class="text-right" :span="12">
          <el-tag>
            <i class="el-icon-info" style="margin-right: 4px" />
            Total: {{ total }}
          </el-tag>
        </el-col>
      </el-row>

      <div class="flex pb-20">
        <div class="box">
          <el-input v-model="search" placeholder="Search" clearable />
        </div>
        <div class="box right">
          <el-button @click="openCreateModal">Add New</el-button>
        </div>
      </div>
      <div class="vxe-table-height card-base card-shadow--medium">
        <vxe-grid
          round
          border="inner"
          ref="xGrid"
          height="100%"
          auto-resize
          empty-text="No Data"
          show-overflow="tooltip"
          highlight-hover-row
          @cell-click="cellClicked"
          @cell-mouseenter="rowHover"
          @cell-mouseleave="rowLeave"
          :data="tableData"
          :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
          :loading="tableLoading"
          :columns="tableColumns"
        />
      </div>
    </div>

    <create-form
      :createVisible="createVisible"
      :clearFormFields="clearFormFields"
      :createProcessing="createProcessing"
      @createOperation="createOperation"
      @cancelOperation="cancelOperation"
    />

    <edit-form
      :editVisible="editVisible"
      :clearFormFields="clearFormFields"
      :editProcessing="editProcessing"
      :selectedButtonLayout="selectedButtonLayout"
      @editOperation="editOperation"
      @cancelOperation="cancelOperation"
    />
  </div>
</template>

<script>
import { debounce } from "lodash";
import { mapActions } from "vuex";
import feathersClient from "../../../feathers/feathers-client";
import { globalEventBus } from "../../../globalEventBus";

import CreateForm from "./components/createForm";
import EditForm from "./components/editForm";

export default {
  name: "ButtonLayoutsTable",

  data() {
    return {
      eventChannel: '',
      createProcessing: false,
      editProcessing: false,
      deleteProcessing: false,
      tableLoading: false,
      tableData: [],
      allButtonLayouts: [],
      search: "",
      visibleActionsId: "",
      editVisible: false,
      createVisible: false,
      clearFormFields: false,
      total: 0,
      selectedButtonLayout: null,
      tableColumns: [
        {
          field: "sprite",
          title: "",
          width: 50,
          slots: {
            default: ({ row }) => {
              return [
                <div class="voxo-square-icon voxo-bg-btn">
                  <v-svg class="voxo-aqua" sprite="telephone-2" />
                </div>
              ];
            }
          }
        },
        {
          field: "name",
          title: "Name",
          sortable: true,
          minWidth: 150
        },
        {
          field: 'start',
          title: 'Start Key',
          sortable: true,
          minWidth: 100
        },
        {
          field: 'end',
          title: 'End Key',
          sortable: true,
          minWidth: 100
        },
        {
          field: "actions",
          title: "",
          minWidth: "150",
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [
                <div v-show={row.id === this.visibleActionsId}>
                  <el-tooltip placement="top" content="Duplicate">
                    <el-button
                      id={"duplicate-" + row.id}
                      icon="el-icon-document"
                      onClick={() => this.duplicateButtonLayout(row.id, row.name)}
                      class="table-action-button icon-blue"
                    />
                  </el-tooltip>
                  <el-tooltip placement="top" content="Edit">
                    <el-button
                      id={"edit-" + row.id}
                      icon="el-icon-edit"
                      onClick={() => this.openEditModal(row.id)}
                      class="table-action-button icon-blue"
                    />
                  </el-tooltip>
                  <el-tooltip placement="top" content="Delete">
                    <el-button
                      id={"delete-" + row.id}
                      icon="el-icon-delete"
                      onClick={() => this.deleteOperation(row.id)}
                      class="table-action-button icon-red"
                    />
                  </el-tooltip>
                </div>
              ];
            }
          }
        }
      ]
    };
  },

  components: {
    CreateForm,
    EditForm
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },
    user() {
      return this.$store.state.auth.user;
    }
  },

  watch: {
    selectedTenant() {
      this.populateTable();
      feathersClient.service('channel-memberships').remove(null,  {query: {channelName: this.eventChannel}});
      this.joinSocketChannel();
    },

    user(){
      this.populateTable();
      if(!this.eventChannel){
        this.joinSocketChannel();
      }
    },

    search: debounce(function() {
      this.searchButtonLayouts();
    }, 500)
  },

  methods: {

    searchButtonLayouts() {
      if (this.search && this.search.length) {
        this.tableData = this.tableData.filter(data =>
          data.name.toLowerCase().includes(this.search.toLowerCase())
        );
      } else {
        this.tableData = [...this.allButtonLayouts];
      }
      this.total = this.tableData.length;
    },

    populateTable() {
      this.tableLoading = true;
      this.tableData = [];
      feathersClient.service('button-layouts').find({
        query: {
          tenantId: this.selectedTenant.id,
          $sort: { name: 1 }
        }
      }).then(res => {
        this.tableLoading = false;
        this.tableData = [...res];
        this.allButtonLayouts = [...res];
        this.total = res.length;
      });
    },

    //General Form and Table Operations
    cellClicked(data) {
      if (data.column.property !== "actions") {
        this.openEditModal(data.row.id);
      }
    },

    rowHover(data) {
      this.visibleActionsId = data.row.id;
    },

    rowLeave() {
      this.visibleActionsId = "";
    },

    openCreateModal() {
      this.createVisible = true;
      this.clearFormFields = false;
    },

    openEditModal(id) {
      this.editVisible = true;
      this.clearFormFields = false;
      feathersClient
        .service("button-layouts")
        .get(id)
        .then(res => {
          this.selectedButtonLayout = res;
          this.editVisible = true;
        });
    },

    duplicateButtonLayout(id, name) {
      this.$confirm(`Duplicate ${name}?`, "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(async () => {
          this.tableLoading = true;
          const buttonLayoutToDuplicate = await feathersClient
            .service("button-layouts")
            .get(id);

          const { tenantId, name, start, end, keys } = buttonLayoutToDuplicate;
          const createBody = {
            tenantId,
            name: `${name} (Duplicate)`,
            start,
            end,
            keys: keys.map(({ type, name, number }) => ({ type, name, number }))
          };
          feathersClient.service('button-layouts').create(createBody)
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Duplicated successfully",
                type: "success"
              });
              this.tableLoading = false;
            })
            .catch(error => {
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }
              this.tableLoading = false;
            });
        })
        .catch(() => true);
    },

    createOperation(createBody) {
      this.$confirm("Process button layout create?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.createProcessing = true;
          feathersClient.service('button-layouts').create(createBody)
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Created successfully!",
                type: "success"
              });
              this.createProcessing = false;
              this.clearFormFields = true;
              this.cancelOperation("create");
            })
            .catch(error => {
              this.clearFormFields = false;

              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }

              this.createProcessing = false;
            });
        })
        .catch(() => true);
    },

    editOperation(editBody) {
      this.$confirm("Process button layout edit?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.editProcessing = true;

          feathersClient.service('button-layouts').patch(this.selectedButtonLayout.id, editBody)
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Edited Successfully!",
                type: "success"
              });
              this.editProcessing = false;

              this.clearFormFields = true;
              this.cancelOperation("edit");
            })
            .catch(error => {
              this.clearFormFields = false;

              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }

              this.editProcessing = false;
            });
        })
        .catch(() => true);
    },

    cancelOperation(type) {
      this.clearFormFields = true;
      if (type === "create") {
        this.createVisible = false;
      } else if (type === "edit") {
        this.editVisible = false;
      }
    },

    deleteOperation(id) {
      this.$confirm("Process button layout delete?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.deleteProcessing = true;

          feathersClient.service('button-layouts').remove(id)
            .then(() => {
              this.deleteProcessing = false;
              this.$notify({
                title: "Success",
                message: "Deleted successfully!",
                type: "success"
              });
            })
            .catch(error => {
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }

              this.deleteProcessing = false;
            });
        })
        .catch(() => true);
    },

    joinSocketChannel(){
      const channelService = feathersClient.service('channel-memberships');
      const data = {
        roomType: 'admins',
        tenantId: this.selectedTenant.id
      };
      channelService.create(data).then(res => {this.eventChannel = `${data.roomType}/${data.tenantId}`});
    },

    removeListeners(){
      feathersClient.service('button-layouts').removeListener('patched');
      feathersClient.service('button-layouts').removeListener('created');
      feathersClient.service('button-layouts').removeListener('removed');
      globalEventBus.$off('appReconnected');
    }

  },

  created() {
    this.populateTable();
    this.joinSocketChannel()


    //add event listeners here.
    //record was updated
    feathersClient.service('button-layouts').on('patched', (data) => {
      const updateIndex = this.tableData.findIndex(item => item.id === data.id);
      const updateAllIndex = this.allButtonLayouts.findIndex(item => item.id === data.id);
      if(updateIndex >= 0){this.tableData.splice(updateIndex, 1, data);}
      if(updateAllIndex >= 0){ this.allButtonLayouts.splice(updateAllIndex, 1, data);}
    });

    //record was created
    feathersClient.service('button-layouts').on('created', (data) => {
      this.tableData.push(data);
      this.allButtonLayouts.push(data);
    });

    //record was deleted
    feathersClient.service('button-layouts').on('removed', (data) => {
      const indexToRemove = this.tableData.findIndex(item => item.id === data.id);
      const indexAllToRemove = this.allButtonLayouts.findIndex(item => item.id === data.id);
      if(indexToRemove >= 0){this.tableData.splice(indexToRemove, 1);}
      if(indexAllToRemove >= 0){this.allButtonLayouts.splice(indexAllToRemove, 1);}
    });


  },

  beforeDestroy() {
    this.removeListeners();
    feathersClient.service('channel-memberships').remove(null, {query:{channelName: this.eventChannel}});
  },
};
</script>
